"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldPropsOverride = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Allows to specify extra props for a field in runtime.
 */
const FieldPropsOverride = () => null;

exports.FieldPropsOverride = FieldPropsOverride;